export const certifications = {
  en: {
    title: 'Certifications & Achievements',
    items: [
      {
        title: 'Creating Autonomous Agents with Generative AI - Meta & I²A² - In progress',
        url: null
      },
      {
        title: 'AI Agents Fundamentals - Hugging Face',
        url: 'https://huggingface.co/datasets/agents-course/certificates/resolve/main/certificates/charlierf/2025-04-09.png'
      },
      {
        title: 'Software Registration – AssessorAI (INPI, Process BR512025000830-9, 2025)',
        url: null
      },
      {
        title: 'Python Data Analytics - Digital Innovation One',
        url: 'https://www.dio.me/certificate/JFVZ9R71/share'
      },
      {
        title: 'AI Immersion 2nd Edition - Alura',
        url: 'https://cursos.alura.com.br/immersion/certificate/90168542-f154-439f-9cff-95f66a5bde88?lang'
      },
      {
        title: 'Machine Learning Mini-course with Scikit-Learn - Federal University of Sergipe',
        url: null
      }
    ]
  },
  pt: {
    title: 'Certificações & Conquistas',
    items: [
      {
        title: 'Criando Agentes Autônomos com IA Generativa - Meta & I²A² - Em andamento',
        url: null
      },
      {
        title: 'AI Agents Fundamentals - Hugging Face',
        url: 'https://huggingface.co/datasets/agents-course/certificates/resolve/main/certificates/charlierf/2025-04-09.png'
      },
      {
        title: 'Registro de Software – AssessorAI (INPI, Processo BR512025000830-9, 2025)',
        url: null
      },
      {
        title: 'Python Data Analytics - Digital Innovation One',
        url: 'https://www.dio.me/certificate/JFVZ9R71/share'
      },
      {
        title: 'Imersão Inteligência Artificial 2ª Edição - Alura',
        url: 'https://cursos.alura.com.br/immersion/certificate/90168542-f154-439f-9cff-95f66a5bde88?lang'
      },
      {
        title: 'Mini-curso de Machine Learning com Scikit-Learn - Universidade Federal de Sergipe',
        url: null
      }
    ]
  }
};